import { useSnackbar } from 'notistack';

import { getErrorMessage } from '@/lib/apiError';

/**
 * Hook for showing toast notifications.
 *
 * Usage:
 *   const notify = useNotify();
 *   notify.success('Profesional creado');
 *   notify.fromError(err); // auto-extracts message from ApiError
 */
export function useNotify() {
  const { enqueueSnackbar } = useSnackbar();

  return {
    success(message: string): void {
      enqueueSnackbar(message, { variant: 'success' });
    },
    error(message: string): void {
      enqueueSnackbar(message, { variant: 'error' });
    },
    info(message: string): void {
      enqueueSnackbar(message, { variant: 'info' });
    },
    warning(message: string): void {
      enqueueSnackbar(message, { variant: 'warning' });
    },
    fromError(err: unknown, fallback?: string): void {
      const message = getErrorMessage(err) || fallback || 'Ocurrió un error.';
      enqueueSnackbar(message, { variant: 'error' });
    },
  };
}
